import BaseService from '@/services/baseService';
import { AxiosResponse } from 'axios';
import { RechnungFilterDto } from '@/types/RechnungFilterDto';
import { LieferantDetailApiDto, TvsLieferantRechnungApiDtoSearchResponseApi } from '@/api-schema';
import clone from 'clone';

export class RechnungService extends BaseService {
    private RECHNUNGEN_URL: string;
    private DOKUMENTE_URL: string;

    constructor() {
        super();
        this.RECHNUNGEN_URL = `${this.BASE_URL}rechnungen`;
        this.DOKUMENTE_URL = `${this.BASE_URL}dokumente`;
    }

    /**
     * Verarbeitung einer fehlgeschlagenen Rechnung erneut auslösen
     * @param tvsLieferantRechnungId Die Rechnungs ID der fehlgeschlagenen Rechnung
     * @returns Ergebnis mit Erfolgsstatus und optionaler Fehlermeldung
     */
    async retryProcessing(tvsLieferantRechnungId: string): Promise<any> {
        return super.POST<any>(`${this.RECHNUNGEN_URL}/fehlerhaft/${tvsLieferantRechnungId}/retry`, {});
    }

    /**
     * Das vorhandene XML-Dokument herunterladen
     * @param xmlDokumentGuid Die XML-Dokument-GUID
     * @returns Die XML-Datei
     */
    async downloadXml(xmlDokumentGuid: string): Promise<AxiosResponse<File>> {
        return super.DOWNLOAD<File>(`${this.DOKUMENTE_URL}/download/${xmlDokumentGuid}`);
    }

    /**
     * Das vorhandene PDF-Dokument anzeigen/herunterladen
     * @param pdfDokumentGuid Die PDF-Dokument-GUID
     * @returns Die PDF-Datei
     */
    async viewPdf(pdfDokumentGuid: string): Promise<AxiosResponse<File>> {
        return super.DOWNLOAD<File>(`${this.DOKUMENTE_URL}/download/${pdfDokumentGuid}`);
    }

    /**
     * Eine fehlgeschlagene oder ausstehende Rechnung löschen
     * @param rechnungId Die Rechnungs-ID (pdfDokumentGuid)
     */
    async deleteFeherhafteRechnung(tvsLieferantRechnungId: string): Promise<any> {
        return super.DELETE(`${this.RECHNUNGEN_URL}/fehlerhaft/${tvsLieferantRechnungId}/`);
    }

    async getAllFehlerhafteRechnungen(filter: RechnungFilterDto): Promise<TvsLieferantRechnungApiDtoSearchResponseApi> {
        return super
            .GET<TvsLieferantRechnungApiDtoSearchResponseApi>(`${this.RECHNUNGEN_URL}/fehlerhaft/` + super.serializeObjectToQuerystring(filter))
            .then((response) => {
                return response;
            });
    }

    async uploadFehlerhafteRechnungDatei(tvsLieferantRechnungId: string, file: File): Promise<any> {
        const formData = new FormData();
        formData.append('datei', file);

        // Clone config to avoid modifying the original
        const config = clone(this.uploadConfig);

        return super.POST<FormData>(`${this.RECHNUNGEN_URL}/Lieferant/${tvsLieferantRechnungId}/upload`, formData, config);
    }

    async downloadFileAdmin(id: string): Promise<AxiosResponse<File>> {
        return super.DOWNLOAD<File>(`${this.DOKUMENTE_URL}/download/` + id).then((response) => {
            return response;
        });
    }
    async loadLieferanten(): Promise<Array<LieferantDetailApiDto>> {
        //todo: evtl URL anpassen
        return super.GET<Array<LieferantDetailApiDto>>(`${this.RECHNUNGEN_URL}/fehlerhaft/lieferanten`).then((response) => {
            return response;
        });
    }
}

export const rechnungService = new RechnungService();
